module.exports = __webpack_public_path__ + "static/media/workingme.1f75a3f9.png";